// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header-container {
    position: sticky;
    top: 0;
    z-index: 20;
}

.header.mg-header {
    --header-border: rgba(17, 17, 17, 0.1);
    --header-text: var(--mg-ink);
    --header-muted: var(--mg-muted);
    --header-surface: #ffffff;
    --header-hover: var(--mg-soft);
    --header-accent: var(--mg-green);
    background: var(--header-surface);
    border-bottom: 1px solid var(--header-border);
    color: var(--header-text);
    font-family: var(--mg-sans);
    font-size: 14px;
    letter-spacing: 0;
    position: relative;
    opacity: 1;
    transform: none;
    transition: transform .72s cubic-bezier(.16,1,.3,1), opacity .46s ease, box-shadow .3s ease !important;
    width: 100%;
    z-index: 1;
}

.header.mg-header.mg-header--hidden {
    opacity: 0;
    pointer-events: none;
    transform: translateY(calc(-100% - 2px));
}

.mg-wrapper {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: none;
    padding: 0 28px;
    width: 100%;
}

.mg-header__announcement {
    border-bottom: 1px solid var(--header-border);
    color: var(--header-muted);
    font-size: 10px;
    letter-spacing: 0.14em;
    padding: 8px 0 7px;
    text-align: center;
    text-transform: uppercase;
}

.mg-header__top {
    align-items: center;
    display: grid;
    gap: 24px;
    grid-template-columns: 1fr auto 1fr;
    min-height: 62px;
}

.mg-header__meta {
    color: var(--header-muted);
    font-size: 12px;
    letter-spacing: 0.18em;
    text-transform: uppercase;
}

.mg-header__logo {
    display: inline-flex;
    grid-column: 2;
    justify-self: center;
    width: clamp(184px, 12vw, 212px);
}

.mg-header__logo img {
    aspect-ratio: 254 / 30;
    display: block;
    height: auto;
    shape-rendering: geometricPrecision;
    width: 100%;
}

.mg-header-top-actions {
    align-items: center;
    display: flex;
    gap: clamp(8px, 1vw, 16px);
    grid-column: 3;
    justify-content: flex-end;
}

.mg-header-search-toggle {
    align-items: center;
    background: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: inline-flex;
    height: 40px;
    justify-content: center;
    padding: 0;
    width: 40px;
}

.mg-header-top-actions__link {
    align-items: center;
    border: 1px solid transparent;
    border-radius: 0;
    color: currentColor;
    cursor: pointer;
    display: inline-flex;
    height: 40px;
    justify-content: center;
    padding: 0;
    position: relative;
    transition: opacity 0.2s ease;
    width: 40px;
}

.mg-header-top-actions__link:hover {
    background: transparent;
    border-color: transparent;
    opacity: 0.55;
    transform: none;
}

.mg-header-top-actions__link svg,
.mg-header-search-toggle svg {
    fill: none;
    height: 25px;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.8;
    width: 25px;
}

.mg-header__main-row {
    align-items: center;
    display: grid;
    gap: clamp(24px, 4vw, 72px);
    grid-template-columns: minmax(0, 1fr) auto;
    min-height: 46px;
    padding: 0;
}

.mg-header__nav-stack {
    display: grid;
    gap: 0;
    min-width: 0;
}

.mg-header__primary-nav {
    grid-column: 1;
    justify-self: start;
    min-width: 0;
}

.nav-links {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 28px;
    list-style: none;
    margin: 0;
    padding: 0;
}

.mg-header__nav-item {
    display: flex;
}

.nav-button {
    background: transparent;
    border: none;
    border-bottom: 1px solid transparent;
    color: var(--header-text);
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.03em;
    line-height: 1;
    padding: 10px 0 9px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    transition: border-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;
    white-space: nowrap;
}

.nav-button:hover {
    opacity: 0.7;
}

.nav-button.active {
    border-bottom-color: var(--header-text);
    color: var(--header-text);
    font-weight: 600;
}

.mg-header__secondary-nav {
    min-width: 0;
    padding-top: 0;
}

.search-form {
    display: none;
    min-width: 0;
}

.search-form.is-open {
    display: flex;
    min-width: min(360px, 36vw);
}

.mg-header-search__field {
    align-items: center;
    background: transparent;
    border: 0;
    border-bottom: 1px solid rgba(17, 17, 17, 0.28);
    border-radius: 0;
    display: flex;
    min-height: 38px;
    width: 100%;
    padding-left: 0;
    transition: border-color 0.2s ease;
}

.mg-header-search__field:focus-within {
    border-color: #171717;
}

.mg-header-search__input {
    background: transparent;
    border: none;
    color: var(--header-text);
    flex: 1;
    font-size: 12px;
    min-width: 0;
    outline: none;
    padding: 0;
}

.mg-header-search__input::placeholder {
    color: #77736e;
}

.search-button {
    align-items: center;
    background: transparent;
    border: none;
    border-left: 0;
    color: var(--header-text);
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
    height: 38px;
    justify-content: center;
    width: 40px;
}

.mg-header__subnav-links {
    align-items: center;
    display: flex;
    flex-wrap: nowrap;
    gap: 0 clamp(22px, 2vw, 34px);
    list-style: none;
    margin: 0;
    overflow-x: auto;
    padding: 0;
    scrollbar-width: none;
    justify-content: center;
}

.mg-header__subnav-links::-webkit-scrollbar {
    display: none;
}

.mg-header__subnav-item {
    display: flex;
}

.mg-header__subnav-link {
    border-bottom: 0;
    color: var(--header-text);
    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.045em;
    line-height: 1.2;
    padding: 12px 0 11px;
    position: relative;
    text-decoration: none;
    text-transform: uppercase;
    transition: color .25s ease;
    white-space: nowrap;
}

.mg-header__subnav-link:hover {
    color: #171717;
}

.mg-header__subnav-link::after { background: currentColor; bottom: 5px; content: ''; height: 1px; left: 50%; position: absolute; transform: translateX(-50%) scaleX(0); transform-origin: center; transition: transform .42s cubic-bezier(.22,.61,.36,1); width: 100%; }
.mg-header__subnav-link:hover::after,
.mg-header__subnav-link:focus-visible::after,
.mg-header__subnav-link.active::after { transform: translateX(-50%) scaleX(1); }

.mg-header__subnav-link.active {
    color: #171717;
    font-weight: 500;
}

@media (max-width: 1024px) {
    .mg-wrapper {
        padding: 0 18px;
    }

    .mg-header__meta {
        display: none;
    }

    .mg-header__main-row {
        grid-template-columns: 1fr;
    }

    .mg-header-search__form {
        justify-self: stretch;
        max-width: none;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .mg-header__main-row {
        grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
    }
}

@media (max-width: 640px) {
    #header-container { position: sticky; }

    .mg-wrapper { padding-left: 16px; padding-right: 16px; }

    .mg-header__top {
        gap: 12px;
        grid-template-columns: 136px minmax(0, 1fr);
        grid-template-rows: 58px auto;
        padding: 0;
        position: relative;
    }

    .mg-header__top .mg-header__logo {
        grid-column: 1;
        grid-row: 1;
        justify-self: start;
        width: 136px;
    }

    .mg-header__primary-nav {
        grid-column: 1 / -1;
        grid-row: 2;
    }

    .mg-header-top-actions {
        grid-column: 2;
        grid-row: 1;
        position: absolute;
        right: 0;
        top: 10px;
        gap: 0;
        justify-self: end;
        width: auto;
        z-index: 1;
    }

    .mg-header-search-toggle { display: inline-flex; }

    .mg-header__main-row { display: block; padding-bottom: 0; }

    .mg-header-search__form {
        background: #fff;
        border-top: 1px solid var(--header-border);
        display: none;
        padding: 8px 0 12px;
    }

    .mg-header-search__form.is-open { display: flex; }

    .mg-header__subnav-link { padding-bottom: 12px; padding-top: 12px; }
    .mg-header__subnav-link::after { bottom: 5px; }
}

@media (max-width: 768px) {
    .mg-header__subnav-links { justify-content: flex-start; }

    .mg-header__announcement {
        font-size: 10px;
        letter-spacing: 0.16em;
    }

    .mg-header__top {
        min-height: 52px;
    }

    .mg-header__main-row {
        gap: 0;
        padding-bottom: 10px;
    }

    .mg-header__logo img {
        height: auto;
    }

    .mg-header__logo {
        width: 186px;
    }

    .nav-links {
        flex-wrap: nowrap;
        overflow-x: auto;
        padding-bottom: 2px;
        scrollbar-width: none;
    }

    .nav-links::-webkit-scrollbar {
        display: none;
    }

    .nav-button {
        padding: 9px 0 8px;
    }

    .mg-header__subnav-links {
        gap: 0 20px;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding-bottom: 2px;
        scrollbar-width: none;
    }

    .mg-header__subnav-link {
        font-size: 14px;
        padding-bottom: 14px;
        padding-top: 14px;
    }

    .mg-header__subnav-links::-webkit-scrollbar {
        display: none;
    }

    .mg-header-search__field {
        min-height: 38px;
    }

    .search-button {
        height: 38px;
        width: 40px;
    }

    .mg-header-top-actions__link {
        height: 36px;
        width: 36px;
    }
}

@media (max-width: 420px) {
    .mg-wrapper {
        padding-left: 18px;
        padding-right: 12px;
    }

    .mg-header__top { grid-template-columns: 124px minmax(0, 1fr); }

    .mg-header-top-actions { gap: 0; }

    .nav-links {
        gap: 26px;
    }

    .mg-header__subnav-links {
        column-gap: 20px;
        flex-wrap: wrap;
        overflow-x: visible;
        row-gap: 0;
    }

    .mg-header__subnav-link {
        padding-bottom: 10px;
        padding-top: 10px;
    }

    .nav-button {
        font-size: 10px;
    }

    .mg-header__logo img {
        height: auto;
    }

    .mg-header__top .mg-header__logo { width: 124px; }

    .mg-header-top-actions__link {
        display: inline-flex;
        height: 34px;
        width: 34px;
    }

    .mg-header-search-toggle { height: 34px; width: 34px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,+BAA+B;IAC/B,yBAAyB;IACzB,8BAA8B;IAC9B,gCAAgC;IAChC,iCAAiC;IACjC,6CAA6C;IAC7C,yBAAyB;IACzB,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,sGAAsG;IACtG,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,6CAA6C;IAC7C,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;IACvB,UAAU;IACV,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,sEAAsE;IACtE,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,+CAA+C;IAC/C,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,yBAAyB;IACzB,OAAO;IACP,eAAe;IACf,YAAY;IACZ,aAAa;IACb,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,2DAA2D;IAC3D,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,iCAAiC,wBAAwB,EAAE,WAAW,EAAE,WAAW,EAAE,WAAW,EAAE,SAAS,EAAE,kBAAkB,EAAE,qCAAqC,EAAE,wBAAwB,EAAE,sDAAsD,EAAE,WAAW,EAAE;AACvQ;;wCAEwC,qCAAqC,EAAE;;AAE/E;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0DAA0D;IAC9D;AACJ;;AAEA;IACI,oBAAoB,gBAAgB,EAAE;;IAEtC,cAAc,kBAAkB,EAAE,mBAAmB,EAAE;;IAEvD;QACI,SAAS;QACT,2CAA2C;QAC3C,6BAA6B;QAC7B,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,WAAW;QACX,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,cAAc;QACd,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,MAAM;QACN,iBAAiB;QACjB,WAAW;QACX,UAAU;IACd;;IAEA,2BAA2B,oBAAoB,EAAE;;IAEjD,uBAAuB,cAAc,EAAE,iBAAiB,EAAE;;IAE1D;QACI,gBAAgB;QAChB,0CAA0C;QAC1C,aAAa;QACb,mBAAmB;IACvB;;IAEA,kCAAkC,aAAa,EAAE;;IAEjD,0BAA0B,oBAAoB,EAAE,iBAAiB,EAAE;IACnE,iCAAiC,WAAW,EAAE;AAClD;;AAEA;IACI,2BAA2B,2BAA2B,EAAE;;IAExD;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,MAAM;QACN,oBAAoB;IACxB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA,kBAAkB,2CAA2C,EAAE;;IAE/D,yBAAyB,MAAM,EAAE;;IAEjC;QACI,SAAS;IACb;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA,mCAAmC,YAAY,EAAE;;IAEjD;QACI,oBAAoB;QACpB,YAAY;QACZ,WAAW;IACf;;IAEA,2BAA2B,YAAY,EAAE,WAAW,EAAE;AAC1D","sourcesContent":["#header-container {\n    position: sticky;\n    top: 0;\n    z-index: 20;\n}\n\n.header.mg-header {\n    --header-border: rgba(17, 17, 17, 0.1);\n    --header-text: var(--mg-ink);\n    --header-muted: var(--mg-muted);\n    --header-surface: #ffffff;\n    --header-hover: var(--mg-soft);\n    --header-accent: var(--mg-green);\n    background: var(--header-surface);\n    border-bottom: 1px solid var(--header-border);\n    color: var(--header-text);\n    font-family: var(--mg-sans);\n    font-size: 14px;\n    letter-spacing: 0;\n    position: relative;\n    opacity: 1;\n    transform: none;\n    transition: transform .72s cubic-bezier(.16,1,.3,1), opacity .46s ease, box-shadow .3s ease !important;\n    width: 100%;\n    z-index: 1;\n}\n\n.header.mg-header.mg-header--hidden {\n    opacity: 0;\n    pointer-events: none;\n    transform: translateY(calc(-100% - 2px));\n}\n\n.mg-wrapper {\n    box-sizing: border-box;\n    margin: 0 auto;\n    max-width: none;\n    padding: 0 28px;\n    width: 100%;\n}\n\n.mg-header__announcement {\n    border-bottom: 1px solid var(--header-border);\n    color: var(--header-muted);\n    font-size: 10px;\n    letter-spacing: 0.14em;\n    padding: 8px 0 7px;\n    text-align: center;\n    text-transform: uppercase;\n}\n\n.mg-header__top {\n    align-items: center;\n    display: grid;\n    gap: 24px;\n    grid-template-columns: 1fr auto 1fr;\n    min-height: 62px;\n}\n\n.mg-header__meta {\n    color: var(--header-muted);\n    font-size: 12px;\n    letter-spacing: 0.18em;\n    text-transform: uppercase;\n}\n\n.mg-header__logo {\n    display: inline-flex;\n    grid-column: 2;\n    justify-self: center;\n    width: clamp(184px, 12vw, 212px);\n}\n\n.mg-header__logo img {\n    aspect-ratio: 254 / 30;\n    display: block;\n    height: auto;\n    shape-rendering: geometricPrecision;\n    width: 100%;\n}\n\n.mg-header-top-actions {\n    align-items: center;\n    display: flex;\n    gap: clamp(8px, 1vw, 16px);\n    grid-column: 3;\n    justify-content: flex-end;\n}\n\n.mg-header-search-toggle {\n    align-items: center;\n    background: transparent;\n    border: 0;\n    color: inherit;\n    cursor: pointer;\n    display: inline-flex;\n    height: 40px;\n    justify-content: center;\n    padding: 0;\n    width: 40px;\n}\n\n.mg-header-top-actions__link {\n    align-items: center;\n    border: 1px solid transparent;\n    border-radius: 0;\n    color: currentColor;\n    cursor: pointer;\n    display: inline-flex;\n    height: 40px;\n    justify-content: center;\n    padding: 0;\n    position: relative;\n    transition: opacity 0.2s ease;\n    width: 40px;\n}\n\n.mg-header-top-actions__link:hover {\n    background: transparent;\n    border-color: transparent;\n    opacity: 0.55;\n    transform: none;\n}\n\n.mg-header-top-actions__link svg,\n.mg-header-search-toggle svg {\n    fill: none;\n    height: 25px;\n    stroke: currentColor;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 1.8;\n    width: 25px;\n}\n\n.mg-header__main-row {\n    align-items: center;\n    display: grid;\n    gap: clamp(24px, 4vw, 72px);\n    grid-template-columns: minmax(0, 1fr) auto;\n    min-height: 46px;\n    padding: 0;\n}\n\n.mg-header__nav-stack {\n    display: grid;\n    gap: 0;\n    min-width: 0;\n}\n\n.mg-header__primary-nav {\n    grid-column: 1;\n    justify-self: start;\n    min-width: 0;\n}\n\n.nav-links {\n    align-items: center;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 28px;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.mg-header__nav-item {\n    display: flex;\n}\n\n.nav-button {\n    background: transparent;\n    border: none;\n    border-bottom: 1px solid transparent;\n    color: var(--header-text);\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0.03em;\n    line-height: 1;\n    padding: 10px 0 9px;\n    text-align: center;\n    text-decoration: none;\n    text-transform: uppercase;\n    transition: border-color 0.2s ease, color 0.2s ease, opacity 0.2s ease;\n    white-space: nowrap;\n}\n\n.nav-button:hover {\n    opacity: 0.7;\n}\n\n.nav-button.active {\n    border-bottom-color: var(--header-text);\n    color: var(--header-text);\n    font-weight: 600;\n}\n\n.mg-header__secondary-nav {\n    min-width: 0;\n    padding-top: 0;\n}\n\n.search-form {\n    display: none;\n    min-width: 0;\n}\n\n.search-form.is-open {\n    display: flex;\n    min-width: min(360px, 36vw);\n}\n\n.mg-header-search__field {\n    align-items: center;\n    background: transparent;\n    border: 0;\n    border-bottom: 1px solid rgba(17, 17, 17, 0.28);\n    border-radius: 0;\n    display: flex;\n    min-height: 38px;\n    width: 100%;\n    padding-left: 0;\n    transition: border-color 0.2s ease;\n}\n\n.mg-header-search__field:focus-within {\n    border-color: #171717;\n}\n\n.mg-header-search__input {\n    background: transparent;\n    border: none;\n    color: var(--header-text);\n    flex: 1;\n    font-size: 12px;\n    min-width: 0;\n    outline: none;\n    padding: 0;\n}\n\n.mg-header-search__input::placeholder {\n    color: #77736e;\n}\n\n.search-button {\n    align-items: center;\n    background: transparent;\n    border: none;\n    border-left: 0;\n    color: var(--header-text);\n    cursor: pointer;\n    display: inline-flex;\n    font-size: 14px;\n    height: 38px;\n    justify-content: center;\n    width: 40px;\n}\n\n.mg-header__subnav-links {\n    align-items: center;\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 0 clamp(22px, 2vw, 34px);\n    list-style: none;\n    margin: 0;\n    overflow-x: auto;\n    padding: 0;\n    scrollbar-width: none;\n    justify-content: center;\n}\n\n.mg-header__subnav-links::-webkit-scrollbar {\n    display: none;\n}\n\n.mg-header__subnav-item {\n    display: flex;\n}\n\n.mg-header__subnav-link {\n    border-bottom: 0;\n    color: var(--header-text);\n    font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    letter-spacing: 0.045em;\n    line-height: 1.2;\n    padding: 12px 0 11px;\n    position: relative;\n    text-decoration: none;\n    text-transform: uppercase;\n    transition: color .25s ease;\n    white-space: nowrap;\n}\n\n.mg-header__subnav-link:hover {\n    color: #171717;\n}\n\n.mg-header__subnav-link::after { background: currentColor; bottom: 5px; content: ''; height: 1px; left: 50%; position: absolute; transform: translateX(-50%) scaleX(0); transform-origin: center; transition: transform .42s cubic-bezier(.22,.61,.36,1); width: 100%; }\n.mg-header__subnav-link:hover::after,\n.mg-header__subnav-link:focus-visible::after,\n.mg-header__subnav-link.active::after { transform: translateX(-50%) scaleX(1); }\n\n.mg-header__subnav-link.active {\n    color: #171717;\n    font-weight: 500;\n}\n\n@media (max-width: 1024px) {\n    .mg-wrapper {\n        padding: 0 18px;\n    }\n\n    .mg-header__meta {\n        display: none;\n    }\n\n    .mg-header__main-row {\n        grid-template-columns: 1fr;\n    }\n\n    .mg-header-search__form {\n        justify-self: stretch;\n        max-width: none;\n    }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n    .mg-header__main-row {\n        grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);\n    }\n}\n\n@media (max-width: 640px) {\n    #header-container { position: sticky; }\n\n    .mg-wrapper { padding-left: 16px; padding-right: 16px; }\n\n    .mg-header__top {\n        gap: 12px;\n        grid-template-columns: 136px minmax(0, 1fr);\n        grid-template-rows: 58px auto;\n        padding: 0;\n        position: relative;\n    }\n\n    .mg-header__top .mg-header__logo {\n        grid-column: 1;\n        grid-row: 1;\n        justify-self: start;\n        width: 136px;\n    }\n\n    .mg-header__primary-nav {\n        grid-column: 1 / -1;\n        grid-row: 2;\n    }\n\n    .mg-header-top-actions {\n        grid-column: 2;\n        grid-row: 1;\n        position: absolute;\n        right: 0;\n        top: 10px;\n        gap: 0;\n        justify-self: end;\n        width: auto;\n        z-index: 1;\n    }\n\n    .mg-header-search-toggle { display: inline-flex; }\n\n    .mg-header__main-row { display: block; padding-bottom: 0; }\n\n    .mg-header-search__form {\n        background: #fff;\n        border-top: 1px solid var(--header-border);\n        display: none;\n        padding: 8px 0 12px;\n    }\n\n    .mg-header-search__form.is-open { display: flex; }\n\n    .mg-header__subnav-link { padding-bottom: 12px; padding-top: 12px; }\n    .mg-header__subnav-link::after { bottom: 5px; }\n}\n\n@media (max-width: 768px) {\n    .mg-header__subnav-links { justify-content: flex-start; }\n\n    .mg-header__announcement {\n        font-size: 10px;\n        letter-spacing: 0.16em;\n    }\n\n    .mg-header__top {\n        min-height: 52px;\n    }\n\n    .mg-header__main-row {\n        gap: 0;\n        padding-bottom: 10px;\n    }\n\n    .mg-header__logo img {\n        height: auto;\n    }\n\n    .mg-header__logo {\n        width: 186px;\n    }\n\n    .nav-links {\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        padding-bottom: 2px;\n        scrollbar-width: none;\n    }\n\n    .nav-links::-webkit-scrollbar {\n        display: none;\n    }\n\n    .nav-button {\n        padding: 9px 0 8px;\n    }\n\n    .mg-header__subnav-links {\n        gap: 0 20px;\n        flex-wrap: nowrap;\n        overflow-x: auto;\n        padding-bottom: 2px;\n        scrollbar-width: none;\n    }\n\n    .mg-header__subnav-link {\n        font-size: 14px;\n        padding-bottom: 14px;\n        padding-top: 14px;\n    }\n\n    .mg-header__subnav-links::-webkit-scrollbar {\n        display: none;\n    }\n\n    .mg-header-search__field {\n        min-height: 38px;\n    }\n\n    .search-button {\n        height: 38px;\n        width: 40px;\n    }\n\n    .mg-header-top-actions__link {\n        height: 36px;\n        width: 36px;\n    }\n}\n\n@media (max-width: 420px) {\n    .mg-wrapper {\n        padding-left: 18px;\n        padding-right: 12px;\n    }\n\n    .mg-header__top { grid-template-columns: 124px minmax(0, 1fr); }\n\n    .mg-header-top-actions { gap: 0; }\n\n    .nav-links {\n        gap: 26px;\n    }\n\n    .mg-header__subnav-links {\n        column-gap: 20px;\n        flex-wrap: wrap;\n        overflow-x: visible;\n        row-gap: 0;\n    }\n\n    .mg-header__subnav-link {\n        padding-bottom: 10px;\n        padding-top: 10px;\n    }\n\n    .nav-button {\n        font-size: 10px;\n    }\n\n    .mg-header__logo img {\n        height: auto;\n    }\n\n    .mg-header__top .mg-header__logo { width: 124px; }\n\n    .mg-header-top-actions__link {\n        display: inline-flex;\n        height: 34px;\n        width: 34px;\n    }\n\n    .mg-header-search-toggle { height: 34px; width: 34px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
